/***
 *
 *   PASSWORD
 *   Update the users password
 *
 *   if the user has a password show old and new inputs
 *   if no existing password (eg. in case of social signin)
 *   then allow the user to set a password on their account
 *
 **********/

import {
  AccountNav,
  Animate,
  AuthContext,
  Form,
  Message,
} from "components/lib";
import { Fragment, useContext, useState } from "react";

export function Password(props) {
  const context = useContext(AuthContext);
  const [done, setDone] = useState(false);

  return (
    <Fragment>
      <AccountNav />
      <Animate>
        <div style={{ backgroundColor: "white", width: 380, padding: 20 }}>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginBottom: 20,
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            Edit your password
          </div>
          {!done ? (
            <Form
              url="/api/user/password"
              method="PUT"
              buttonText="Save Password"
              inputs={{
                ...(context.user.has_password && {
                  has_password: {
                    type: "hidden",
                    value: true,
                  },
                }),
                newpassword: {
                  label: "Create New Password",
                  type: "password",
                  required: true,
                  complexPassword: true,
                },
              }}
              callback={() => {
                setDone(true);
                context.update({ has_password: true });
              }}
            />
          ) : (
            <Message
              title="Password Saved"
              type="success"
              text="Your new password has been saved successfully."
            />
          )}
        </div>
      </Animate>
    </Fragment>
  );
}
